import { Component, Input, Output, EventEmitter } from '@angular/core';
@Component({
    selector: 'app-table-controller',
    template: ''
})
export class TableController {
    constructor() { }
    @Output() onSort = new EventEmitter();
    sort(btn, column) {
        // add icon...
        let dir = '';
        switch (btn.className) {
            case '':
            case 'sort-btn sort-desc datatable-icon-down':
                btn.className = 'sort-btn sort-asc datatable-icon-up';
                dir = 'asc';
                break;
            case 'sort-btn sort-asc datatable-icon-up':
                btn.className = 'sort-btn sort-desc datatable-icon-down';
                dir = 'desc';
                break;
        }
        this.onSort.emit({ dir: dir, column: column });
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_models/Classes/table-controller.ts